import * as React from "react";
import "../../../assets/scss/components/header/globalSearch.scss";
import { apiService } from "../../service/apiService";
import { IGSearchRes } from "../../types/components/search";
import urlConfig, { config } from "../../../config/domain";
import moment from "moment";
import ComaprisonSearch from "./comparisonSearch";
import { SectorSearch } from "./sectorSearch";
import { Idevice } from "../../types/device";
import DeviceContext from "../../service/indentifyDevice";
import { useState } from "react";

interface IGSearchResultsProps {
  sw: string;
  av: string | null;
  sr: Array<any>;
}
const handleDevice: Idevice = DeviceContext();

interface IGlobalSearch {}

export const GlobalSearch = (_props: IGlobalSearch) => {
  const [active, setActive] = useState<boolean>(false);
  // const [loading, setLoading] = useState<boolean>(false);
  const [results, setResults] = useState<IGSearchResultsProps | null>();
  const [query, setQuery] = useState<string>("");

  const [compData, setCompData] = useState<{
    stringContent: string;
    oneBoxContent: any;
  }>({ stringContent: "", oneBoxContent: null });

  const [message, setMessage] = useState<string>("");
  const [smartTipText, setSmartTipText] = useState<string>("");
  const userQueryInput = React.useRef<HTMLInputElement>(null);

  //abort controller for API calls
  const searchControllerRef = React.useRef<AbortController | null>();
  const redirectSearchControllerRef = React.useRef<AbortController | null>();

  let timeout: NodeJS.Timer;
  const GlobalSearchAbort = (controller: AbortController) => {
    searchControllerRef.current = controller; //get api call signal ref
  };

  const RedirectSearchAbort = (controller: AbortController) => {
    searchControllerRef.current = controller; //get api call signal ref
  };

  const smartTipApiCall = (res: string) => {
    res && setSmartTipText(res);
  };
  const bindData = (res: IGSearchResultsProps) => {
    if (res) {
      if (res.sr) {
        for (let i = 0; i < res.sr.length; i++) {
          if (res.sr[i].nd) {
            let temp = res.sr[i].nd.split(" ");
            temp[0] = temp[0].split("/");
            temp[0] = temp[0][2] + "-" + temp[0][1] + "-" + temp[0][0];
            res.sr[i].nd = temp[0] + " " + temp[1];
          }
        }
        setResults(res);
        message && setMessage("");
      }
      if (
        (res.sr ? !res.sr.length : false) &&
        query &&
        !compData.oneBoxContent
      ) {
        setMessage("SORRY WE COULD NOT FIND ANY RELEVANT RESULTS FOR YOU");
      }
    }
  };
  //when user focus out of the search box reset search input to empty and disable active flag
  const activeSearch = (val: boolean) => {
    setActive(val);
    if (!val) {
      setQuery("");
      let ele = document.getElementById("GSearchAnything") as HTMLInputElement;
      if (ele) {
        ele.value = "";
        setResults(undefined);
      }
    }
  };
  const searchBtnClicked = (): void => {
    throw new Error("Method not implemented.");
  };
  const getRedirectDataSuccess = (res: {
    stringContent: "";
    oneBoxContent: null;
  }) => {
    if (res) {
      if (res.oneBoxContent) {
        setMessage("");
      }
      setCompData(res);
    }
  };
  const getRedirectData = (inpQuery: string, searchRoute?: string) => {
    if (redirectSearchControllerRef.current) {
      redirectSearchControllerRef.current.abort(); //abort prevoius API calls
    }
    var postData = {
      searchString: inpQuery,
      searchRoute: "",
    };
    apiService(
      {
        url: urlConfig.GSearch.GetSearchRedirectResult,
        method: "POST",
        body: postData,
      },
      getRedirectDataSuccess,
      RedirectSearchAbort
    );
  };
  const getSearchSuggestions = () => {
    try {
      if (searchControllerRef.current) {
        searchControllerRef.current.abort(); //abort prevoius API calls
      }
      let searchval: string = userQueryInput.current?.value
        ? userQueryInput.current?.value
        : "";
      setQuery(searchval);

      if (searchval.length > 2) {
        timeout && clearTimeout(timeout);
        timeout = setTimeout(() => {
          getRedirectData(searchval);
        }, 1000);

        var postData = {
          SearchString: searchval,
          Cookie: "",
        };
        apiService(
          {
            url: urlConfig.GSearch.GSearchSuggestions,
            method: "POST",
            body: postData,
          },
          bindData,
          GlobalSearchAbort
        );
      } else if (searchval.length === 0) {
        setResults(undefined);
      }
    } catch (err) {
      //console.log(err);
    }
  };

  const sgListItem = (listItem: IGSearchRes) => {
    return (
      <span className="stkPrice">
        {listItem.pr}
        <span className="">
          <span
            className={
              parseFloat(listItem.cn) > 0
                ? " posVal"
                : parseFloat(listItem.cn) < 0
                ? "negVal"
                : ""
            }
          >
            {parseFloat(listItem.cn) > 0 && <span>&#x25B2;</span>}
            {parseFloat(listItem.cn) < 0 && <span>&#x25BC;</span>}
            {listItem.cn}({`${listItem.pn}%`})
          </span>
          {listItem.nd && (
            <>
              <span className="asOn">
                <span className="edel-icon-clock"></span>
                <span className=" ">
                  &nbsp;
                  {moment(new Date(listItem.nd)).format("MMM DD, hh:mm a")}
                </span>
              </span>
            </>
          )}
        </span>
      </span>
    );
  };

  const sgListEle = (listItem: IGSearchRes, index: number) => {
    return (
      <li className="resultItem" key={index}>
        <a className="redirectLink" href={config.rootUrl + listItem.rt}>
          {listItem.sg}
          {listItem.pr && <p>{sgListItem(listItem)}</p>}
        </a>
      </li>
    );
  };

  const handleDocumentClick = (e: MouseEvent) => {
    const eTar = e.target as HTMLElement;
    eTar && eTar.id !== "GSearchAnything" && !active && activeSearch(false);
  };

  React.useEffect(() => {
    apiService(
      {
        url: urlConfig.web_mw + "Market/smartTipText/",
        method: "GET",
      },
      smartTipApiCall
    );
    window.addEventListener("click", (e) => handleDocumentClick(e));

    return () => {};
  }, []);

  return (
    <div className={`${active ? "active" : ""} searchContainer`}>
      <div className="gSearchOverlay"></div>
      <div className="searchGrp">
        {/* contains search suggestion */}
        {active && (
          <div className="searchStrip">
            <p className="">
              <i className="edel-icon-flash"></i>
              <i className=""></i> <span>SMART TIP:</span> {smartTipText}
            </p>
          </div>
        )}
        <button
          className="edBtn closeSearch"
          onClick={() => activeSearch(false)}
        >
          <i className="edel-icon-close"></i>
        </button>
        <form name="gSearch">
        <button
            className="btnSearch edBtn ib vMid"
            onClick={() => searchBtnClicked()}
          >
            <i className="icon-searchNH icon-b icon-25"></i>
          </button>
          <input
            ref={userQueryInput}
            type="text"
            className="searchBox ib vMid"
            id="GSearchAnything"
            placeholder="What are you looking for?"
            maxLength={50}
            autoComplete="off"
            onClick={() => activeSearch(true)}
            onChange={() => getSearchSuggestions()}
          />
         
        </form>

        {/* //show the search suggestion fetched from suggestions api */}
        {((results && results?.sr.length !== 0) || message) && active && (
          <div className="searchResults stringSearch">
            {results && results?.sr.length !== 0 && (
              <div
                className={
                  "resultsDiv " + (handleDevice.isDesktop ? "by2" : "")
                }
              >
                <ul className="searchResultsListCont vTop">
                  {results?.sr.map(
                    (listItem: IGSearchRes, index: number) =>
                      index < 5 && sgListEle(listItem, index)
                  )}
                </ul>
                <ul className="searchResultsListCont vTop">
                  {results?.sr.map(
                    (listItem: IGSearchRes, index: number) =>
                      index >= 5 && sgListEle(listItem, index)
                  )}
                </ul>
              </div>
            )}
            {message && <p className="no_results">{message}</p>}
          </div>
        )}

        {/* //if there are no search suggestions fetched from suggestions api then show direct results api response here*/}

        {results?.sr.length === 0 &&
          compData?.oneBoxContent &&
          (compData?.oneBoxContent.type === "comparison" ||
            compData?.oneBoxContent.type === "datapoint") &&
          active && (
            <div className="searchResults">
              <div
                className={
                  compData?.oneBoxContent.type +
                  (compData?.oneBoxContent.type === "comparison" &&
                  handleDevice.isDesktop
                    ? " by2"
                    : "")
                }
              >
                <ComaprisonSearch
                  deviceState={handleDevice}
                  oneBoxContent={compData?.oneBoxContent}
                />
              </div>
            </div>
          )}
        {results?.sr.length === 0 &&
          compData?.oneBoxContent &&
          compData?.oneBoxContent.type === "sector" &&
          active && (
            <div className="searchResults sectorSearch">
              <SectorSearch oneBoxContent={compData?.oneBoxContent} />
            </div>
          )}
      </div>
    </div>
  );
};
